import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { log } from "../log";

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    backend: {
      loadPath: "/messages/{{lng}}.json",
      allowMultiLoading: false
    },

    nsSeparator: false,

    debug: false,

    supportedLngs: ["en"],
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === "intlDate") {
          return new Intl.DateTimeFormat(lng, {
            year: "numeric",
            month: "long",
            day: "numeric"
          }).format(value);
        } else if (format === "intlDateTime") {
          return new Intl.DateTimeFormat(lng, {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
          }).format(value);
        }

        return value;
      }
    },

    parseMissingKeyHandler: (key) => {
      log.error("Request for unknown i18n key: %s", key);
      throw new Error(`Missing message key: ${key}`);
    }
  });
